import React from 'react'

import { Title } from "../../../../../elements/Typography"

const trackTitle = ({
    title,
}) => (
        <Title
            size={4}
            content={title}
            typeClass="track-title"
        />
    )

export default trackTitle
